<template>
  <div>
    <v-dialog persistent v-model="dialog" scrollable width="350">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          <span>
            <slot name="header">Confirm?</slot>
          </span>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col sm="12">
              <span>
                <slot :selected="selected"
                  ><span>
                    Are you sure you want to delete this item?
                  </span></slot
                >
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="dialog = !dialog">{{
            closeText
          }}</v-btn>
          <v-btn @click="callDelete" outlined color="primary">{{
            confirmText
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    delete: {
      type: Function,
      required: true,
    },
    closeText: {
      type: String,
      default: 'Cancel',
    },
    confirmText: {
      type: String,
      default: 'Delete',
    },
  },
  data() {
    return {
      selected: {},
      dialog: false,
    }
  },
  created() {},
  computed: {
  },
  methods: {
    deleteConfirm(item) {
      this.selected = item
      this.dialog = true
    },
    async callDelete() {
      try {
        await this.delete(this.selected)
        this.$emit('refresh')
        this.dialog = false
      } catch (err) {
        this.$emit('error', err)
      }
    },
  },
}
</script>
<style scoped></style>
